module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum02-d9228dd7d6419d809dadaae0feb546ab.png";